// extracted by mini-css-extract-plugin
export default {"modalError":"styles_modalError__WA4d3","btns":"styles_btns__NeRdQ","supportBtn":"styles_supportBtn__egFLk","supportBtnTitle":"styles_supportBtnTitle__ToF2F"};